export const taskListItemCompiler = ({ renderer }) =>
  (renderer.listitem = function (item) {
    const isTaskItem = item.task;
    let text = '';
    let checkboxText = '';
    if (isTaskItem) {
      checkboxText = this.checkbox?.({ checked: !!item.checked });
    }
    text = this.parser.parse(item.tokens) || '';
    text = text.replace(/^<p>/, '').replace(/<\/p>$/, '');
    text = checkboxText + text;
    const html = isTaskItem
      ? /* html */ `<li class="task-list-item"><label>${text}</label></li>`
      : /* html */ `<li>${text}</li>`;

    return html;
  });
